import cookie from 'cookie';

export function animationEnabled() {
  return !cookie.parse(document.cookie).disableAnimations;
}

export function invalidate(elm: HTMLElement | null, time: number) {
  if (elm) {
    const animationsEnabled = animationEnabled();
    if (animationsEnabled) setTimeout(() => elm.classList.add('animate'), time);
    else elm.classList.add('animate');
  }
}
